import React from "react";

const PlanCard = ({ name, price, description, note, onSubscribe, imageUrl, rotisPerDay }) => {
  const getPlanEmoji = (planName) => {
    if (planName.toLowerCase().includes('basic')) return '🥖';
    if (planName.toLowerCase().includes('standard')) return '🌟';
    if (planName.toLowerCase().includes('mega')) return '👨‍👩‍👧‍👦';
    return '🍽️';
  };

  const getFeatures = () => {
    const features = [];
    if (typeof rotisPerDay !== 'undefined') {
      features.push(`🥟 ${rotisPerDay} rotis/day`);
    }
    if (description.includes('Free Delivery')) {
      features.push('🚚 Free delivery');
    }
    if (description.includes('Sweet on Sat')) {
      features.push('🍰 Sweet on Saturday');
    }
    if (description.includes('2–3 members')) {
      features.push('👪 Serves 2–3 members');
    }
    if (description.includes('4–5 members')) {
      features.push('👨‍👩‍👧‍👦 Serves 4–5 members');
    }
    if (description.includes('light eaters')) {
      features.push('👤 Ideal for light eaters');
    }
    return features;
  };

  return (
    <div className="bg-white rounded-3xl shadow-xl p-0 mb-8 max-w-xs mx-auto flex flex-col border border-gray-100 hover:shadow-2xl transition-all duration-300">
      {/* Accent bar at the top */}
      <div className="h-2 w-full rounded-t-3xl bg-gradient-to-r from-green-400 to-green-600"></div>
      {/* Image area */}
      <div className="w-full h-40 flex items-center justify-center bg-gray-50 rounded-t-3xl overflow-hidden">
        <img
          src={imageUrl || "/images/plan-placeholder.png"}
          alt={name}
          className="object-cover w-full h-full"
        />
      </div>
      {/* Card content */}
      <div className="flex-1 flex flex-col justify-between p-6">
        <div className="text-center mb-4">
          <div className="text-4xl mb-2">{getPlanEmoji(name)}</div>
          <h3 className="text-xl font-bold text-green-800 mb-1">{name}</h3>
          <div className="text-3xl font-extrabold text-green-700 mb-1">{price}</div>
          <div className="text-sm text-gray-500 mb-2">per month</div>
        </div>
        <ul className="text-gray-700 space-y-2 mb-4">
          {getFeatures().map((feature, index) => (
            <li key={index} className="flex items-center text-sm">
              <span className="mr-2">{feature}</span>
            </li>
          ))}
        </ul>
        {note && (
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mb-4">
            <p className="text-yellow-800 text-sm italic">💡 {note}</p>
          </div>
        )}
        <button
          onClick={() => onSubscribe({
            name,
            price,
            rotisPerDay
          })}
          className="w-full bg-green-600 text-white py-3 rounded-full font-semibold text-lg hover:bg-green-700 transition-all duration-200 transform hover:scale-105 shadow-lg mt-2"
        >
          🚀 Subscribe Now
        </button>
      </div>
    </div>
  );
};

export default PlanCard; 